(() => {
  function initProduct(section) {
    if (section.dataset.productReady) return;
    const data = section.querySelector('[data-product-variants]');
    let variants;
    try { variants = JSON.parse(data.textContent); } catch (_) { return; }
    if (!Array.isArray(variants) || !variants.length) return;
    section.dataset.productReady = 'true';
    const form = section.querySelector('form');
    const select = section.querySelector('[data-variant-select]');
    const optionGroups = [...section.querySelectorAll('[data-option-index]')];
    const slides = [...section.querySelectorAll('[data-image-id]')];
    const gallery = section.querySelector('[data-gallery]');
    const controls = section.querySelector('[data-gallery-controls]');
    const counter = section.querySelector('[data-image-count]');
    const add = section.querySelector('[data-product-add]');
    const availability = section.querySelector('[data-availability]');
    let active = Math.max(0, slides.findIndex(slide => !slide.hidden));
    let current = variants.find(variant => String(variant.id) === select.value);

    function showImage(index) {
      if (!slides.length) return;
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== active; });
      const image = slides[active].querySelector('img');
      if (image) image.loading = 'eager';
      if (counter) counter.textContent = `${active + 1} / ${slides.length}`;
    }
    function showVariantImage(variant) {
      const index = slides.findIndex(slide => slide.dataset.imageId === String(variant.imageId));
      if (index >= 0) showImage(index);
    }
    function values() {
      return optionGroups.map(group => group.querySelector('input:checked')?.value);
    }
    function updateAvailability(selected) {
      optionGroups.forEach((group, index) => {
        const selection = group.querySelector('[data-option-selection]');
        selection.textContent = selected[index] || '';
        group.querySelectorAll('input').forEach(input => {
          const possible = variants.some(variant => variant.available && variant.options.every((value, i) => value === (i === index ? input.value : selected[i])));
          input.closest('label').classList.toggle('is-unavailable', !possible);
          input.setAttribute('aria-label', `${input.value}${possible ? '' : ' - unavailable with current options'}`);
        });
      });
    }
    function updateVariant(variant, updateURL) {
      current = variant;
      select.value = variant ? String(variant.id) : '';
      add.disabled = !variant?.available;
      add.textContent = !variant ? 'Unavailable' : variant.available ? section.dataset.addLabel : 'Sold out';
      availability.hidden = Boolean(variant?.available);
      availability.textContent = variant ? 'Sold out' : 'This combination is unavailable. Choose another option.';
      const price = section.querySelector('[data-product-price]');
      const compare = section.querySelector('[data-compare-price]');
      const sku = section.querySelector('[data-product-sku]');
      if (price) price.textContent = variant ? variant.price : '—';
      if (compare) { compare.hidden = !variant?.onSale; compare.textContent = variant?.comparePrice || ''; }
      if (sku) { sku.hidden = !variant?.sku; sku.textContent = variant?.sku ? `SKU: ${variant.sku}` : ''; }
      if (variant) showVariantImage(variant);
      if (updateURL) {
        const url = new URL(window.location.href);
        if (variant) url.searchParams.set('variant', variant.id);
        else url.searchParams.delete('variant');
        window.history.replaceState(window.history.state, '', url);
      }
      updateAvailability(values());
    }

    if (controls) controls.hidden = false;
    showImage(active);
    section.querySelector('[data-image-prev]')?.addEventListener('click', () => showImage(active - 1));
    section.querySelector('[data-image-next]')?.addEventListener('click', () => showImage(active + 1));
    gallery?.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault(); showImage(active + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    let touch;
    gallery?.addEventListener('touchstart', event => {
      const point = event.touches[0]; touch = { x: point.clientX, y: point.clientY };
    }, { passive: true });
    gallery?.addEventListener('touchend', event => {
      if (!touch) return;
      const point = event.changedTouches[0];
      const dx = point.clientX - touch.x, dy = point.clientY - touch.y;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) showImage(active + (dx < 0 ? 1 : -1));
      touch = null;
    }, { passive: true });

    if (optionGroups.length) {
      section.querySelector('[data-variant-options]').hidden = false;
      section.querySelector('[data-variant-fallback]').hidden = true;
      optionGroups.forEach(group => group.addEventListener('change', () => {
        const selected = values();
        updateVariant(variants.find(variant => variant.options.every((value, i) => value === selected[i])), true);
      }));
    }
    select.addEventListener('change', () => {
      const variant = variants.find(item => String(item.id) === select.value);
      if (variant) optionGroups.forEach((group, index) => group.querySelectorAll('input').forEach(input => { input.checked = input.value === variant.options[index]; }));
      updateVariant(variant, true);
    });
    form.addEventListener('submit', event => {
      if (!current?.available) { event.preventDefault(); availability.hidden = false; }
    });
    updateVariant(current, false);
  }
  function init(scope) {
    if (scope.matches?.('[data-quarry-product]')) initProduct(scope);
    scope.querySelectorAll('[data-quarry-product]').forEach(initProduct);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
